import { Generator } from 'shared/utils/models';

const TYPE = 'accountGroup';
export default new Generator(TYPE).createSystemListModel();
